import React from "react";
import { useParams, useLocation } from "react-router-dom";
import BookingSuccess from "../../components/newBookingFlow/BookingSuccess";
import GlobalHeader from "../../components/newBookingFlow/GlobalHeader";
import { Helmet } from "react-helmet";

const BookingSuccessView = ({ ReactGA, GTM, fbEvent }) => {
  const { bookingId } = useParams();
  const location = useLocation();

  // Get booking and cart data from navigation state
  const { bookingData, cartData } = location.state || {};

  return (
    <div className="booking-success-view">
      <Helmet>
        <title>
          Booking Confirmed - Booking #{bookingData?.posBookingKey || bookingId}{" "}
          - Concierge Car Wash
        </title>
        <meta
          name="description"
          content="Your car wash booking has been confirmed. View your booking details and get directions to your selected location."
        />
      </Helmet>

      <GlobalHeader />

      <BookingSuccess
        bookingId={bookingId}
        bookingData={bookingData}
        cartData={cartData}
        ReactGA={ReactGA}
        GTM={GTM}
        fbEvent={fbEvent}
      />
    </div>
  );
};

export default BookingSuccessView;
